var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.formattedErrors.length)?_c('Alert',{staticClass:"validation-errors",attrs:{"type":"danger"}},[_c('ul',_vm._l((_vm.formattedErrors),function(error,i){return _c('li',{key:i},[_vm._v(" "+_vm._s(error)+" ")])}),0)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }